import PortfolioRiskHistory from './PortfolioRiskHistory'

export default PortfolioRiskHistory
